import React, { Component } from 'react'
import { Container, Row, Col } from 'reactstrap';
import { CustomInput, Label, Input, FormGroup, FormFeedback, Form, Modal, ModalHeader, ModalBody, ModalFooter  } from 'reactstrap';
import EirButton from '../eir-button/EirButton';
import EirFieldset from '../eirFieldset/EirFieldset'
import {RealexHpp}  from './rxp-js';
import Stepper from 'react-stepper-horizontal';
import axios from 'axios';
import Loading from '../shared/Loading';
import EirErrorModal from './EirErrorModal';
import { EIR_WEBMAIL_CONST } from './constants/EirWebmailConstants';
import Constants from '../../Constants'

class EirWebmailPayment extends Component {

    constructor(props) {
        super(props);
        if(sessionStorage.getItem('webmailLoggedinUser') == null && !window.location.href.includes("opencms")) {
            window.location.href = '/email/login'
        }
        this.customerName = React.createRef();
        this.std = React.createRef();
        this.mobileNumber = React.createRef();
        this.otp = React.createRef();
        this.state = {        
            errorModal:false,
            emailId:sessionStorage.getItem('webmailLoggedinUser'),
            token: sessionStorage.getItem("WEBMAIL_ADD_TOKEN"),
            signUpText: 'To sign up, please enter your details below',
            declinedErrorModal:false,
            signupLoading:true,
            signup:false,
            payment: false,
            paymentSuccess: false,
            verificationCodeDisplay: false,
            mobileNumberInvalid:false,
            mobileNumberVerified: false,
            mobileVerifyModel:false,
            std: '',
            customerName:'',
            mobileNumber:'',
            contactNumber:'',
            verificationCode:'',
            otpInvalid:false,
            regEx : /^[0-9\b]+$/,
            sendcode:true,
            sendingCode:false,
            stepper: 0,           
            response:'',
            displayIframe:false,
            loading:false,      
            invalid: false,
            stds: [
                "083",
                "085",
                "086",
                "087",
                "088",
                "089",
            ],         
        }
        this.checkForSignup();     
        this.validateInput = this.validateInput.bind(this);
    }
    componentDidMount() {
        window.onbeforeunload = function() {
        sessionStorage.setItem("webmailLoggedinUser", this.state.emailId)
        }.bind(this);
    }
    checkForSignup= () => {
    let current = this;
        axios({
            method: 'get',
            url: EIR_WEBMAIL_CONST.url.GET_SUBSCRIBER_URL+current.state.emailId,
            headers: {
                Authorization: 'Bearer ' + current.state.token,
                }
            }).then( function(res) {
                if(res.data.status == "PENDING_ACTIVE"){
                     current.setState({
                        signupLoading : false,
                        customerName: res.data.name,
                        contactNumber: res.data.number,
                        paymentPopup : true
                    })
                    current.getElavonHPP(res.data.name);
                }
                else{
                    window.location.href = '/email/login'
                }
                
            }).catch(function(err){
                if(err.response.status == 404){
                    current.setState ({
                        signupLoading : false,
                        signup : true,
                    })
                }
                else if (err.response.status === 403) {
                    return window.location.href = '/email/login'
                }
                else{
                    current.setState({
                        errorModal:true,
                        signupLoading : false,
                    })
                }
            })

    }
    onHandleNumber = (event) =>{      
        const regEx = this.state.regEx;    
        if(event.target.value ==='' || regEx.test(event.target.value)){
            if(event.target.name=='mobileNumber'){
                this.setState({
                    mobileNumber: event.target.value,
                    mobileNumberInvalid: (event.target.value.length != 7) ? true : false
                })
            }
            else if((event.target.name=='verificationCode')){
                this.setState({verificationCode: event.target.value })
            }           
        }  
 
    }

    displayIframe = () => {
        let current=this;
        current.setState({loading: false,displayIframe: true,  })
    }

    getVerficationCode = (event) => {
        let form = event.target;
        event.preventDefault();
        event.stopPropagation();
        form = $("form")[0];
        form[0].required = false;
        let current = this;      
        if (current.mobileNumber.current.value.length == 7) {

        current.setState({
            contactNumber: current.std.current.value+current.mobileNumber.current.value,
            sendcode: false,
            reSendCode:false,
            sendingCode:true,
        });

        axios({
            method: 'post',
            url: EIR_WEBMAIL_CONST.url.OTP_VERIFICATION_URL,
            data: {           
                "msisdn":current.std.current.value+current.mobileNumber.current.value            
                  }
            }).then( function(res) {
                current.setState({
                    sendingCode:false,
                    otpUuid: res.data.otpUuid,
                    verificationCodeDisplay: true,  
                    verificationCode:'',
                    otpInvalid:false,
                    reSendCode:true,
                });
            }).catch(function(err){
                current.setState({
                    sendingCode:false,
                    reSendCode:true,
                    errorModal:true,
                });
            })     
        } 
        form.classList.add('was-validated');      
   }
    handleStd = (event) => {
        this.setState({
            std: event.target.value
        })
    }

    toggleModel = () =>{
        this.setState({
            mobileVerifyModel: false,
            paymentPopup: false,
            declinedErrorModal:false,
        })
    }
    
    validateInput = (event) => {
        let form = event.target;
        let current = this;
        event.preventDefault();
        event.stopPropagation();
        form = $("form")[0];
        form[0].required = true;
        form[4].required = true;
       
        if (form.checkValidity()) {

            if(this.state.verificationCodeDisplay){

            axios({
                method: 'post',
                url: EIR_WEBMAIL_CONST.url.OTP_VERIFICATION_URL +current.state.otpUuid+'/validate',
                data: {           
                    "otp": this.otp.current.value,             
                    }
                }).then( function(res) {
                    if(res.data.valid)
                    {
                        current.setState({ 
                            otpInvalid: false,                            
                        });
                        current.setState({
                            customerName: current.customerName.current.value
                        })  
                        current.getElavonHPP(current.customerName.current.value); 
                   }  
                       
            }).catch(function(err){
                current.setState({          
                otpInvalid: true,          
                });
            }) 
        }
        else{
            current.setState({
                mobileVerifyModel: true
            })
        }

    }
        form.classList.add('was-validated');
    }

    getElavonHPP = (customerName) =>
    {
        let current = this;
        current.setState({  
            signup: false,    
            payment: true,             
            stepper: 1,
            loading: true, 
        });

        axios({
            method: 'post',
            url: EIR_WEBMAIL_CONST.url.PROSPECT_URL+'create',
            headers: {
                Authorization: 'Bearer ' + current.state.token,
                },
            data: {
                "email":this.state.emailId,
                "name": customerName,
                "number": this.state.contactNumber,
                "plan": "plan599",
                "terms": true
                }
            }).then( function(res) {
                current.setState({  
                    response: res.data,   

                });
                axios({
                    method: 'get',
                    url: EIR_WEBMAIL_CONST.url.PAYMENT_CENTER_STATUS,
                    }).then( function(res) {
                        if(res.data.status == "UP"){
                            RealexHpp.embedded.init(
                                "pay-button",
                                "targetIframe",             
                                "localhost",
                                current.state.response,
                                current.submitPayment);
                        }
                        else{
                            current.setState({ 
                                loading: false,
                                paymentCenterDown: true,
                            });
                        }
                    }).catch(function(err){
                        current.setState({ 
                            loading: false,
                            paymentCenterDown: true,
                        });
                    })

               }).catch(function(err){
                current.setState({ 
                    errorModal:true,
                    loading: false,
                    payment: false,             
                    stepper: 0,
                    verificationCodeDisplay:false,
                    sendcode:true,
                    reSendCode:false,
                    mobileNumber:'',
                    verificationCode:'',
                });
                
            })        
    }

    submitPayment = (hppResponse) => {
        let current = this;
        current.setState({ 
            loading:true,
              
        });
        axios({
            method: 'get',
            url: EIR_WEBMAIL_CONST.url.GET_SUBSCRIBER_URL+current.state.emailId,
            headers: {
                Authorization: 'Bearer ' + current.state.token,
                }
            }).then( function(res) {
               
                axios({
                    method: 'post',
                    url: EIR_WEBMAIL_CONST.url.PROSPECT_URL +res.data.uuid+'/callback',
                    headers: {
                        Authorization: 'Bearer ' + current.state.token,
                        },
                    data: {   
                            "encoded": true,
                            "hppResponse": hppResponse                             
                        }
                    }).then( function(result) {
                        current.setState({ 
                            loading:false,
                            signUpText: '',
                            paymentSuccess: true,
                            stepper: 2,   
                        });
                    }).catch(function(err){

                        axios({
                            method: 'get',
                            url: EIR_WEBMAIL_CONST.url.GET_SUBSCRIBER_URL+current.state.emailId,
                            headers: {
                                Authorization: 'Bearer ' + current.state.token,
                                }
                            }).then( function(res) {
                                if(res.data.status == "PENDING_ACTIVE"){
                                    current.setState({ 
                                        loading:false,
                                        displayIframe:false,
                                        payment: false,             
                                        stepper: 0,
                                        declinedErrorModal:true,
                                    });
                                    current.getElavonHPP(res.data.name);
                                }
                                else if(res.data.status == "ACTIVE"){
                                    current.setState({ 
                                        loading:false,
                                        signUpText: '',
                                        paymentSuccess: true,
                                        stepper: 2,   
                                    }); 
                                }         
                            }).catch(function(err){
                                current.setState({          
                                errorModal: true,         
                                });
                            })    
                    })
                }).catch(function(err){
                    current.setState({ 
                        loading:false,
                        errorModal:true,
                        displayIframe:false,
                        payment: false,             
                        stepper: 0,
                    });
                })
    };
    
    toggleError = (param) => {
        let current = this;
        current.setState({
            errorModal: param
        })
    }

    //strips off the html tags received from openCMS and prints only the cotent
    renderContent = (content) => {
        return { __html: content };
    }

    render() {

        return (

        <div className=" mb-3 mb-md-5 mt-4 eir-theme-default container webmail-container">
                <h2 className="eir-title-container eir-title display-4 eir-display-xl-3">Payment</h2>
                {this.props.text.length > 0 &&
                <p className="ml-4 mt-4 eir-text text-center" dangerouslySetInnerHTML={this.renderContent(this.props.text)}></p>
                }
            <Container>    
            <EirFieldset legend={this.state.signUpText} border='solid'>
                <div>
                <Stepper steps={ [{title: 'Personal Details'}, {title: 'Payment Setup'}, {title: 'Payment Success'}] } activeStep={ this.state.stepper } activeColor= {Constants.siteTheme.primaryTheme} completeColor={Constants.siteTheme.primaryTheme} />
                </div>
                {/* For Payment SignUp Form */}
                {(this.state.signupLoading) && 
                     <div style={{minHeight:"500px"}} >
                    <h4 style={{paddingTop:"150px"}} className=" text-center mt-5 text-secondary mt-4">Loading...</h4>
                    <Loading />
                    </div>
                } 
                {this.state.signup &&
                <Row className="textfield-toggle">            
                    <Form method="post"  className="col-lg-12 mt-5">
                   
                        <FormGroup className="col-lg-6 mb-3">
                        <Label className="payment-title">Email<span className=""></span></Label>
                        <p style={{fontSize:"1.1rem"}} >{this.state.emailId}</p>
                        </FormGroup>
                        
                        <FormGroup className="col-lg-6 mb-3">
                        <Label className="payment-title">Name<span className="mandatory">*</span></Label>
                        <Row>
                        <Col xs="12"  sm='9' md='6' lg='10'>  
                        <Input name="customerName" className="payment-text width-field"  innerRef={this.customerName}  type="text"  required />
                            <FormFeedback>Please enter name</FormFeedback>
                        </Col>

                        </Row>
                        </FormGroup>
                        
                        
                        <FormGroup className=" col-lg-12 mb-3">
                        <Label className="payment-title">Mobile Number<span className="mandatory">*</span></Label>
                        <Row>
                        <Col xs="auto"  sm='auto' md='auto' lg='auto'>
                            <Input className={" payment-text  "+(this.state.mobileNumberVerified ?'read-only' : '')}
                            type="select"
                            style={{width:"120%"}}
                            innerRef={this.std}
                            value={this.state.std}
                            onChange={this.handleStd}
                            readOnly={this.state.mobileNumberVerified}
                            required> 
                            {this.state.stds.map((stds, i) => <option key={i}>{stds}</option>)}
                            </Input>
                        </Col>
                        <Col xs="8"  sm='7' md='4' lg='4'>
                            <Input className={" payment-text  " +(this.state.mobileNumberVerified ?'read-only' : '')}
                            innerRef={this.mobileNumber} 
                            type='text'
                            name="mobileNumber"
                            onChange={this.onHandleNumber}
                            value={this.state.mobileNumber}
                            pattern="[0-9]*"
                            minLength='7'                      
                            maxLength='7'
                            invalid={this.state.mobileNumberInvalid}
                            readOnly={this.state.mobileNumberVerified}
                            required/>
                            <FormFeedback>Enter 7 digit Mobile Number</FormFeedback>
                        </Col>
                        <Col xs='12' sm='12' md='6' lg='6' className="mt-2" >
                            {this.state.sendcode && 
                            <EirButton
                                type="link"
                                text="Send Verfication Code"
                                onClick={this.getVerficationCode}
                            />
                            }
                            {this.state.reSendCode && 
                            <div>
                            <p style={{marginBottom:"0"}}>Code has been sent to your mobile. If not received, Please click &nbsp;
                             
                            <span>    
                            <EirButton
                                className="pb-2 pl-1 pr-1"
                                type="link"
                                text="Resend Code"
                                onClick={this.getVerficationCode}
                            />  
                            </span>
                            </p>  
                            </div> 
                            }  
                            {(this.state.sendingCode) && 
                            <div>
                            <Loading/>
                            </div>
                            }   
                        </Col>
                        </Row>
                        </FormGroup>
                        
                        
                        {this.state.verificationCodeDisplay &&                         
                        <FormGroup className="col-lg-12 mb-3">
                        <Label className="payment-title">Verification code<span className="mandatory">*</span></Label>
                        <Row>
                        <Col xs='12' sm='9' md='6' lg='5' className="mr-mobile">
                            <Input 
                            className={"payment-text width-field"}
                            name="verificationCode" 
                            type="tel"
                            autoComplete='off'
                            innerRef={this.otp}
                            pattern="^[0-9]*$"
                            readOnly={this.state.mobileNumberVerified}
                            onChange={this.onHandleNumber}
                            value={this.state.verificationCode}
                            invalid= {this.state.otpInvalid}
                            maxLength='6'                        
                            id="verificationCode"  />
                            <FormFeedback>Please enter a valid verification code</FormFeedback>
                        </Col>
                        </Row>
                        </FormGroup>
                        }
                        
                        
                        {!this.state.payment && 
                        <div className="mt-3 col-lg-12 d-flex">
                            <EirButton id="pay-button"
                                type="button"
                                text="Continue"
                                name="Submit"
                                value="Submit"
                                className="btn btn-primary mt-3 webmail-btn"
                                onClick={this.validateInput}
                            />
                        </div>
                        }
                        <p className="ml-2 mt-3">By using this service you agree to <a  aria-label="View the terms and conditions" href="https://www.eir.ie/opencms/export/sites/default/.content/pdf/terms/eir_net_domain_tsandcs.pdf" target="_blank">Terms &amp; Conditions. </a></p>
                
                        <Modal centered={true} isOpen={this.state.mobileVerifyModel} toggle={this.toggleModel} >
                            <ModalHeader toggle={this.toggleModel}>Alert</ModalHeader>
                            <ModalBody>
                            <p className="text-center">Please Verify your Mobile Number</p> 
                            </ModalBody>
                            <ModalFooter>
                            <EirButton type="button" text="Ok" onClick={this.toggleModel}></EirButton>{' '}        
                            </ModalFooter>
                        </Modal>
                    </Form>
                </Row>   
                }
                {/* For retreiving Elavon Hpp  */}
                {this.state.paymentCenterDown && 
                 <div className="d-flex justify-content-center align-items-center">
                   <p className="mt-3 text-danger text-center">We are currently unable to process this payment - Please try again later</p>
                </div>
                } 
                {this.state.payment && !this.state.paymentSuccess && <div>
                   
                 <Modal centered={true} isOpen={this.state.paymentPopup} toggle={this.toggleModel} >
                 <ModalHeader toggle={this.toggleModel}>Alert</ModalHeader>
                 <ModalBody>
                 <p className="text-center">Unfortunately your setup was not complete, please enter your payment details to activate your webmail subscription.</p> 
                 </ModalBody>
                 <ModalFooter>
                 <EirButton type="button" text="Ok" onClick={this.toggleModel}></EirButton>{' '}        
                 </ModalFooter>
                </Modal>
               
                <Row>                                
                    <div className= {"display-content mt-5 " +(this.state.displayIframe ?'' : 'hidden')} >
                    <iframe  id="targetIframe" onLoad={this.displayIframe}  style={{display:'inline-block',width:'100%',align:'centre',minHeight:'600px',position:'relative',marginTop:'1rem'}}frameBorder="0" >
                    </iframe> 
                    </div>

                   </Row>
                </div>
                }
               
                 {(this.state.loading) && (
                     <div style={{minHeight:"500px"}} >
                    <h4 style={{paddingTop:"150px"}} className=" text-center mt-5 text-secondary mt-4">Loading...</h4>
                    <Loading />
                    </div>
                )}  
                {/* for Payment Success */}
                {this.state.paymentSuccess &&  !this.state.loading &&
                <Row>                   
                <div className="display-content" style={{textAlign:"center"}}>
                    {this.props.successImage &&
                    <img className="mt-5" src={this.props.successImage} /> 
                    }  
                    {this.props.successText &&     
                    <h4 className="ml-4 mt-5 mb-5 eir-text text-center" dangerouslySetInnerHTML={this.renderContent(this.props.successText)} ></h4>       
                    }
                    <div className="text-center mt-3">
                    <EirButton
                        type="button"
                        text="Go To Webmail Login"
                        link="/email/login"
                        className="btn btn-primary webmail-btn"
                        name="redirectTo"
                    />
                    </div>
                </div>
                </Row>
                }
                {
                this.state.errorModal &&
                <EirErrorModal toggleError={this.toggleError} errorModal={this.state.errorModal} />
                }
                <Modal centered={true} isOpen={this.state.declinedErrorModal} toggle={this.toggleModel} >
                            <ModalHeader toggle={this.toggleModel}>Alert</ModalHeader>
                            <ModalBody className='text-center'>
                            Your payment was declined. <br/>
                            Please try again
                            </ModalBody>
                            <ModalFooter>
                            <EirButton type="button" text="Ok" onClick={this.toggleModel}></EirButton>{' '}        
                            </ModalFooter>
                </Modal>   
            </EirFieldset>
            </Container>
        </div>
        )
    }
}
export default EirWebmailPayment;